import { useUser } from '../Contexts/UserContext';
import ClientEnergyTracker from '../Screens/Client/EnergyTracker';
import TenantEnergyTracker from '../Screens/Tenant/EnergyTracker';

export default function EnergyTracker() {
    const { type } = useUser();

    return (
        <>
            {type === 'client' && <ClientEnergyTracker />}
            {type === 'tenant' && <TenantEnergyTracker />}
        </>
    );
}